import React, { useState, useEffect, useRef, Fragment } from "react";
import "../Scheduler/Scheduler.css";
import CalanderIcon from "../../../components/Assests/Calander-Icon.png";
import CloseVector from "../../../components/Assests/Close-Vector.png";
import CloseIcon from "../../../components/Assests/Close-Icon.png";
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import {
  getSchedulerSummary,
  getAnalystAssignedSamples,
  getProductSamples,
  unassignSamples,
  assignSamples,
  getAnalystNames,
  getAssignedProductsCount,
  getSamplesForRemove
} from "./SchedularApi";
import SecondTab from "../../../components/organisms/secondTab";
import PageDescriptionBar from "../../../components/atoms/pageDescriptionBar/PageDescriptionBar";

const parseDateStringToUTC = (dateString) => {
  if (!dateString) return null;
  const [y, m, d] = dateString.split("-").map(Number);
  return new Date(Date.UTC(y, m - 1, d));
};

const formatDateToInputUTC = (date) => {
  return `${date.getUTCFullYear()}-${String(date.getUTCMonth() + 1).padStart(2, "0")}-${String(date.getUTCDate()).padStart(2, "0")}`;
};

const addDaysUTC = (date, days) => {
  const d = new Date(date.getTime());
  d.setUTCDate(d.getUTCDate() + days);
  return d;
};

const getNearestSundayUTC = (date = new Date()) => {
  const d = parseDateStringToUTC(formatDateToInputUTC(date));
  const day = d.getUTCDay();
  d.setUTCDate(d.getUTCDate() - day);
  return d;
};

const todayUTCString = () => formatDateToInputUTC(new Date());

const isDateValidUTC = (dateString) => {
  if (!dateString) return false;
  const selected = parseDateStringToUTC(dateString);
  const today = parseDateStringToUTC(todayUTCString());
  return selected.getTime() >= today.getTime();
};

const createUTCDateMidday = (dateString) => {
  if (!dateString) return null;
  const [y, m, d] = dateString.split("-").map(Number);
  return new Date(Date.UTC(y, m - 1, d, 12, 0, 0));
};

const formatDisplayMMDDYYUTC = (dateString) => {
  if (!dateString) return "";
  const d = parseDateStringToUTC(dateString);
  return `${String(d.getUTCMonth() + 1).padStart(2, "0")}/${String(d.getUTCDate()).padStart(2, "0")}/${String(d.getUTCFullYear()).slice(-2)}`;
};

const formatDateDDMMYY = (dateString) => {
  if (!dateString) return "";
  const d = new Date(dateString);
  return `${String(d.getUTCDate()).padStart(2, "0")}/${String(d.getUTCMonth() + 1).padStart(2, "0")}/${String(d.getUTCFullYear()).slice(-2)}`;
};

const parseApiDate = (apiDateString) => {
  const datePart = apiDateString.split('T')[0];
  return datePart;
};

const parseProductsAssigned = (productsArray) => {
  if (!Array.isArray(productsArray)) return [];
  return productsArray.map(item => {
    const match = item.match(/^(.+)\((\d+)\)$/);
    return {
      productTypeName: match ? match[1] : item,
      name: match ? match[1] : item,
      count: match ? parseInt(match[2]) : 0,
      productCount: match ? parseInt(match[2]) : 0,
      displayText: item,
      productWithSampleCount: item
    };
  });
};

const getTodayDateString = () => todayUTCString();

const Scheduler = ({ TabConfig }) => {
  useEffect(() => {
    document.body.classList.add('scheduler-active');
    return () => {
      document.body.classList.remove('scheduler-active');
    };
  }, []);

  const initialSunday = formatDateToInputUTC(getNearestSundayUTC());
  const [fromDate, setFromDate] = useState(initialSunday);
  const [toDate, setToDate] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [activeWeek, setActiveWeek] = useState("Week 1");
  const [showPopup, setShowPopup] = useState(false);
  const [popupDragOffset, setPopupDragOffset] = useState({ x: 0, y: 0 });
  const [isPopupDragging, setIsPopupDragging] = useState(false);
  const popupDragStartRef = useRef({ x: 0, y: 0 });
  const popupDragOriginRef = useRef({ x: 0, y: 0 });
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [deleteTaskInfo, setDeleteTaskInfo] = useState({ task: "", analyst: "", day: "", sampleIds: [] });
  const [selectedSamplesToDelete, setSelectedSamplesToDelete] = useState([]);
  const [selectedAnalyst, setSelectedAnalyst] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedSamples, setSelectedSamples] = useState([]);
  const [currentSampleList, setCurrentSampleList] = useState([]);
  const [scheduleData, setScheduleData] = useState([]);
  const [assignedProductsFromSchedule, setAssignedProductsFromSchedule] = useState([]);
  const [analysts, setAnalysts] = useState([]);
  const [productSamples, setProductSamples] = useState([]);
  const [productSamplesLoading, setProductSamplesLoading] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [hasSearched, setHasSearched] = useState(false);
  const [samplesForRemove, setSamplesForRemove] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);

  const forceRefresh = () => {
    setRefreshKey(prev => prev + 1);
  };

  useEffect(() => {
    if (!fromDate) return;
    const from = parseDateStringToUTC(fromDate);
    const toDateCalculated = addDaysUTC(from, 13);
    setToDate(formatDateToInputUTC(toDateCalculated));
  }, [fromDate]);

  useEffect(() => {
    if (selectedProduct && selectedAnalyst && selectedDate) {
      const fetchAssignedProductsCount = async () => {
        try {
          const result = await getAssignedProductsCount(selectedAnalyst, selectedDate);
          if (result?.productsassigned && Array.isArray(result.productsassigned)) {
            const mappedProducts = parseProductsAssigned(result.productsassigned);
            setAssignedProductsFromSchedule(mappedProducts);
          } else if (Array.isArray(result) && result.length > 0) {
            setAssignedProductsFromSchedule(result);
          } else {
            setAssignedProductsFromSchedule([]);
          }
        } catch (err) {
          console.error('Error fetching assigned products:', err);
          setAssignedProductsFromSchedule([]);
        }
      };
      fetchAssignedProductsCount();
    }
  }, [selectedProduct, selectedAnalyst, selectedDate]);

  useEffect(() => {
    const initializeData = async () => {
      setIsLoading(true);
      try {
        const nearestSunday = getNearestSundayUTC(new Date());
        const calculatedFromDate = formatDateToInputUTC(nearestSunday);
        const calculatedToDate = formatDateToInputUTC(addDaysUTC(nearestSunday, 13));
        setFromDate(calculatedFromDate);
        setToDate(calculatedToDate);
        setCurrentSampleList([]);
        const [summaryData, analystData, assignedData] = await Promise.all([
          getSchedulerSummary(),
          getAnalystNames(),
          getAnalystAssignedSamples({
            fromDate: calculatedFromDate,
            toDate: calculatedToDate
          })
        ]);
        const mappedSummary = (summaryData?.data || summaryData || []).map((item, idx) => ({
          id: item.id || `sample-${idx}`,
          name: `${item.productTypeName || item.productName} (${item.productCount})`,
          assayCount: item.assayCount || 0,
          reAssay1Count: item.reAssay1Count || 0,
          reAssay2Count: item.reAssay2Count || 0,
          status: item.status || (item.productCount > 10 ? 'green' : 'red'),
        }));
        setCurrentSampleList(mappedSummary);
        const processedAnalystData = Array.isArray(analystData) ? analystData : (analystData.data || []);
        setAnalysts(processedAnalystData);
        if (Array.isArray(assignedData)) {
          const scheduleDataWithAssignments = processedAnalystData.map(analyst => {
            const analystName = analyst.fullName || analyst.name || analyst.userName;
            const analystId = analyst.userId || analyst.id;
            const analystSchedule = { analyst: analystName, analystId };
            const assignedDataForAnalyst = assignedData.find(data =>
              data.analyst?.toLowerCase().trim() === analystName.toLowerCase().trim()
            );
            if (assignedDataForAnalyst?.receiveddates) {
              assignedDataForAnalyst.receiveddates.forEach(dateData => {
                if (!dateData.receivedDate) return;
                const dateKey = parseApiDate(dateData.receivedDate);
                if (dateData.schedulerSamplesProDuctsDto?.length > 0) {
                  analystSchedule[dateKey] = {
                    products: dateData.schedulerSamplesProDuctsDto.map(product => ({
                      name: product.productTypeName,
                      count: product.samplesCount,
                      productCount: product.productCount,
                      sampleIds: product.sampleIds,
                      displayText: product.productWithSampleCount
                    }))
                  };
                }
              });
            }
            return analystSchedule;
          });
          setScheduleData(scheduleDataWithAssignments);
        } else {
          setScheduleData(createEmptyScheduleWithAnalysts(processedAnalystData));
        }
        setHasSearched(true);
      } catch (error) {
        setAnalysts([]);
        setCurrentSampleList([]);
        setScheduleData([]);
      }
      setIsLoading(false);
    };
    initializeData();
  }, [refreshKey]);

  useEffect(() => {
    updateAssignedProducts();
  }, [selectedAnalyst, selectedDate, scheduleData, analysts]);

  const fetchCurrentSamples = async () => {
    try {
      const summary = await getSchedulerSummary();
      const mapped = (summary?.data || summary || []).map((item, idx) => ({
        id: item.id || `sample-${idx}`,
        name: `${item.productTypeName || item.productName} (${item.productCount})`,
        assayCount: item.assayCount || 0,
        reAssay1Count: item.reAssay1Count || 0,
        reAssay2Count: item.reAssay2Count || 0,
        status: item.status || (item.productCount > 10 ? 'green' : 'red'),
      }));
      setCurrentSampleList(mapped);
    } catch (err) { setCurrentSampleList([]); }
  };

  const createEmptyScheduleWithAnalysts = (analystList) => {
    return analystList.map(analyst => ({
      analyst: analyst.fullName || analyst.name || analyst.userName,
      analystId: analyst.userId || analyst.id
    }));
  };

  const getAssignedProductsForAnalystAndDate = (analystName, dateKey) => {
    if (!analystName || !dateKey || !scheduleData.length) return [];
    const analystData = scheduleData.find(row =>
      row.analyst?.toLowerCase().trim() === analystName.toLowerCase().trim()
    );
    if (!analystData || !analystData[dateKey]) return [];
    return analystData[dateKey].products || [];
  };

  const updateAssignedProducts = () => {
    if (!selectedAnalyst || !selectedDate) {
      setAssignedProductsFromSchedule([]);
      return;
    }
    const analystObj = analysts.find(a =>
      String(a.userId || a.id) === String(selectedAnalyst)
    );
    if (!analystObj) {
      setAssignedProductsFromSchedule([]);
      return;
    }
    const analystName = analystObj.fullName || analystObj.name || analystObj.userName;
    const assignedProducts = getAssignedProductsForAnalystAndDate(analystName, selectedDate);
    setAssignedProductsFromSchedule(assignedProducts);
  };

  const generateDateHeaders = () => {
    const startDate = parseDateStringToUTC(fromDate);
    const endDate = parseDateStringToUTC(toDate);
    if (!startDate || !endDate) return [];

    const dateHeaders = [];
    const startSunday = getNearestSundayUTC(startDate);
    let currentDate = new Date(startSunday.getTime());

    while (currentDate.getTime() <= endDate.getTime()) {
      const dayName = new Intl.DateTimeFormat('en-US', { weekday: 'short', timeZone: 'UTC' }).format(currentDate);
      const dateStr = new Intl.DateTimeFormat('en-US', { month: '2-digit', day: '2-digit', timeZone: 'UTC' }).format(currentDate);
      const yyyyMMdd = formatDateToInputUTC(currentDate);

      dateHeaders.push({
        label: `${dayName}, ${dateStr}`,
        date: new Date(currentDate),
        key: yyyyMMdd
      });

      currentDate = addDaysUTC(currentDate, 1);
    }

    return dateHeaders;
  };

  const dateHeaders = generateDateHeaders();
  const currentWeekDates = activeWeek === "Week 1" ? dateHeaders.slice(0, 7) : dateHeaders.slice(7, 14);

  const formatDateForDisplay = (dateString) => formatDisplayMMDDYYUTC(dateString);

  const handleDeleteClick = async (task, analyst, day, sampleIds) => {
    try {
      const samplesData = await getSamplesForRemove(sampleIds);
      const filteredSamples = samplesData.filter(sample =>
        sampleIds.includes(sample.sampleId)
      );
      setSamplesForRemove(filteredSamples);
      setDeleteTaskInfo({ task, analyst, day, sampleIds });
      setSelectedSamplesToDelete(sampleIds || []);
      setShowDeleteConfirm(true);
    } catch (error) {
      console.error('Error fetching samples for remove:', error);
      const fallbackSamples = sampleIds.map(id => ({
        sampleId: id,
        productName: task
      }));
      setSamplesForRemove(fallbackSamples);
      setDeleteTaskInfo({ task, analyst, day, sampleIds });
      setSelectedSamplesToDelete(sampleIds || []);
      setShowDeleteConfirm(true);
    }
  };

  const openSamplePopup = async (sample) => {
    setSelectedProduct(sample);
    setShowPopup(true);
    setProductSamplesLoading(true);
    setSelectedSamples([]);
    setAssignedProductsFromSchedule([]);
    setSelectedAnalyst("");
    setSelectedDate("");
    try {
      const productTypeName = sample.name.split("(")[0].trim();
      const data = await getProductSamples(productTypeName);
      setProductSamples(data || []);
    } catch (err) { setProductSamples([]); }
    finally { setProductSamplesLoading(false); }
  };

  const handleConfirmDelete = async () => {
    const { task, analyst } = deleteTaskInfo;
    if (!selectedSamplesToDelete || !selectedSamplesToDelete.length) {
      toast.error("No samples selected for deletion");
      return;
    }
    try {
      await unassignSamples(selectedSamplesToDelete);
      setShowDeleteConfirm(false);
      setDeleteTaskInfo({ task: "", analyst: "", day: "", sampleIds: [] });
      setSelectedSamplesToDelete([]);
      setSamplesForRemove([]);
      forceRefresh();
      toast.success(`Successfully unassigned ${selectedSamplesToDelete.length} sample(s) for ${task} from ${analyst}`);
    } catch (err) {
      console.error("Delete error:", err);
      toast.error("Failed to unassign samples. Please try again.");
    }
  };

  const handleDateSelection = (e) => {
    const selectedDateValue = e.target.value;
    const today = todayUTCString();
    if (selectedDateValue >= today) {
      setSelectedDate(selectedDateValue);
    } else {
      setSelectedDate("");
      toast.error("Cannot assign samples to past dates. Please select today or a future date.");
    }
  };

  const handleAssign = async () => {
    if (!selectedSamples.length || !selectedAnalyst || !selectedDate) {
      toast.error("Please select analyst, date and samples");
      return;
    }
    if (!isDateValidUTC(selectedDate)) {
      toast.error("Cannot assign samples to past dates");
      return;
    }
    try {
      const payload = {
        Analyst: selectedAnalyst,
        SampleIds: selectedSamples,
        DateToWorkOn: createUTCDateMidday(selectedDate).toISOString()
      };
      const analystObj = analysts.find(a =>
        String(a.userId || a.id) === String(selectedAnalyst)
      );
      const analystName = analystObj ?
        (analystObj.fullName || analystObj.name || analystObj.userName) :
        'Selected analyst';

      await assignSamples(payload);

      setShowPopup(false);
      setSelectedSamples([]);
      setSelectedAnalyst("");
      setSelectedDate("");
      setSelectedProduct(null);
      setAssignedProductsFromSchedule([]);

      forceRefresh();

      toast.success(`Successfully assigned ${selectedSamples.length} sample(s) to ${analystName} for ${formatDateForDisplay(selectedDate)}`);
    } catch (err) {
      const errorMessage = err?.response?.data?.errors?.Analyst?.[0] ||
        err?.response?.data?.message ||
        "Failed to assign samples";
      toast.error(errorMessage);
    }
  };

  const refreshSchedulerData = async () => {
    setIsLoading(true);
    try {
      setCurrentSampleList([]);
      const [summaryData, assignedData] = await Promise.all([
        getSchedulerSummary(),
        getAnalystAssignedSamples({
          fromDate: fromDate,
          toDate: toDate
        })
      ]);
      const mappedSummary = (summaryData?.data || summaryData || []).map((item, idx) => ({
        id: item.id || `sample-${idx}`,
        name: `${item.productTypeName || item.productName} (${item.productCount})`,
        assayCount: item.assayCount || 0,
        reAssay1Count: item.reAssay1Count || 0,
        reAssay2Count: item.reAssay2Count || 0,
        status: item.status || (item.productCount > 10 ? 'green' : 'red'),
      }));
      setCurrentSampleList(mappedSummary);
      if (Array.isArray(assignedData)) {
        const updatedScheduleData = analysts.map(analyst => {
          const analystName = analyst.fullName || analyst.name || analyst.userName;
          const analystId = analyst.userId || analyst.id;
          const analystSchedule = { analyst: analystName, analystId };
          const assignedDataForAnalyst = assignedData.find(data =>
            data.analyst?.toLowerCase().trim() === analystName.toLowerCase().trim()
          );
          if (assignedDataForAnalyst?.receiveddates) {
            assignedDataForAnalyst.receiveddates.forEach(dateData => {
              if (!dateData.receivedDate) return;
              const dateKey = parseApiDate(dateData.receivedDate);
              if (dateData.schedulerSamplesProDuctsDto?.length > 0) {
                analystSchedule[dateKey] = {
                  products: dateData.schedulerSamplesProDuctsDto.map(product => ({
                    name: product.productTypeName,
                    count: product.samplesCount,
                    productCount: product.productCount,
                    sampleIds: product.sampleIds,
                    displayText: product.productWithSampleCount
                  }))
                };
              }
            });
          }
          return analystSchedule;
        });
        setScheduleData(updatedScheduleData);
        setHasSearched(true);
      }
    } catch (error) {
      toast.error("Failed to refresh data");
    }
    setIsLoading(false);
  };

  const handleAnalystSelection = (e) => {
    setSelectedAnalyst(e.target.value);
  };

  const handleSearch = async () => {
    setIsLoading(true);
    try {
      setCurrentSampleList([]);
      const [summaryData, assignedData] = await Promise.all([
        getSchedulerSummary(),
        getAnalystAssignedSamples({
          fromDate: fromDate,
          toDate: toDate
        })
      ]);
      const mappedSummary = (summaryData?.data || summaryData || []).map((item, idx) => ({
        id: item.id || `sample-${idx}`,
        name: `${item.productTypeName || item.productName} (${item.productCount})`,
        assayCount: item.assayCount || 0,
        reAssay1Count: item.reAssay1Count || 0,
        reAssay2Count: item.reAssay2Count || 0,
        status: item.status || (item.productCount > 10 ? 'green' : 'red'),
      }));
      setCurrentSampleList(mappedSummary);
      if (Array.isArray(assignedData)) {
        const updatedScheduleData = analysts.map(analyst => {
          const analystName = analyst.fullName || analyst.name || analyst.userName;
          const analystId = analyst.userId || analyst.id;
          const analystSchedule = { analyst: analystName, analystId };
          const assignedDataForAnalyst = assignedData.find(data =>
            data.analyst?.toLowerCase().trim() === analystName.toLowerCase().trim()
          );
          if (assignedDataForAnalyst?.receiveddates) {
            assignedDataForAnalyst.receiveddates.forEach(dateData => {
              if (!dateData.receivedDate) return;
              const dateKey = parseApiDate(dateData.receivedDate);
              if (dateData.schedulerSamplesProDuctsDto?.length > 0) {
                analystSchedule[dateKey] = {
                  products: dateData.schedulerSamplesProDuctsDto.map(product => ({
                    name: product.productTypeName,
                    count: product.samplesCount,
                    productCount: product.productCount,
                    sampleIds: product.sampleIds,
                    displayText: product.productWithSampleCount
                  }))
                };
              }
            });
          }
          return analystSchedule;
        });
        setScheduleData(updatedScheduleData);
        setHasSearched(true);
      }
    } catch (error) {
      toast.error("Failed to refresh data");
    }
    setIsLoading(false);
  };

  const handlePopupClose = () => {
    setShowPopup(false);
    setSelectedSamples([]);
    setSelectedAnalyst("");
    setSelectedDate("");
    setSelectedProduct(null);
    setAssignedProductsFromSchedule([]);
    setPopupDragOffset({ x: 0, y: 0 });
  };

  const handlePopupHeaderPointerDown = (e) => {
    if (e.button !== 0) return;
    if (e.target.closest("button, input, select, textarea, a")) return;
    popupDragStartRef.current = { x: e.clientX, y: e.clientY };
    popupDragOriginRef.current = popupDragOffset;
    setIsPopupDragging(true);

    const onMove = (moveEvent) => {
      setPopupDragOffset({
        x: popupDragOriginRef.current.x + (moveEvent.clientX - popupDragStartRef.current.x),
        y: popupDragOriginRef.current.y + (moveEvent.clientY - popupDragStartRef.current.y),
      });
    };

    const onUp = () => {
      setIsPopupDragging(false);
      window.removeEventListener("pointermove", onMove);
      window.removeEventListener("pointerup", onUp);
    };

    window.addEventListener("pointermove", onMove);
    window.addEventListener("pointerup", onUp);
  };

  return (
    <Fragment>
      <SecondTab tabConfig={TabConfig} />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <PageDescriptionBar items={[
        { type: "icon", icon: "📅", text: "Assign – Schedule selected samples to an analyst for a specific date" },
        { type: "icon", icon: "➡️", text: "Week 1 / Week 2 – Navigate between the two scheduling weeks" },
        { type: "separator" },
        { type: "icon", icon: "🗑", text: "Delete – Remove a scheduled assignment from the calendar" },
      ]} />
      <div className="scheduler-container default-font-styles">
        <div className="header-controls">
          <div className="header-controls-left">
            <div className="date-input-group">
              <label className="date-label from default-font-styles">From</label>
              <div className="date-input-wrapper">
                <input
                  type="text"
                  value={formatDateForDisplay(fromDate)}
                  readOnly
                  className="date-input-display default-font-styles"
                />
                <img
                  src={CalanderIcon}
                  alt="Calendar"
                  className="calendar-icon"
                />
                <input
                  type="date"
                  value={fromDate}
                  onChange={(e) => {
                    setFromDate(e.target.value);
                  }}
                  className="date-input-hidden"
                />
              </div>
            </div>
            <div className="date-input-group">
              <label className="date-label to default-font-styles">To</label>
              <div className="date-input-wrapper">
                <input
                  type="text"
                  value={formatDateForDisplay(toDate)}
                  readOnly
                  disabled
                  className="date-input-display default-font-styles"
                />
                <img
                  src={CalanderIcon}
                  alt="Calendar"
                  className="calendar-icon"
                />
                <input
                  type="date"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                  className="date-input-hidden"
                  min={fromDate}
                  disabled
                />
              </div>
            </div>
            <button
              className="btn-common outlined-active-btn btn-md default-font-styles"
              onClick={handleSearch}
            >
              Search
            </button>
          </div>
          <div className="header-controls-right">
            <span className="status-indicator default-font-styles">
              <span className="status-dot green"></span>
              Due &gt; 10
            </span>
            <span className="status-indicator default-font-styles">
              <span className="status-dot red"></span>
              Due &gt; 14
            </span>
          </div>
        </div>
        <div className="main-content">
          <div className="schedule-table">
            <div className="week-buttons">
              <button
                className={`week-button week1 default-font-styles ${activeWeek === "Week 1" ? "active" : "inactive"}`}
                onClick={() => setActiveWeek("Week 1")}
              >
                Week 1
              </button>
              <button
                className={`week-button default-font-styles ${activeWeek === "Week 2" ? "active" : "inactive"}`}
                onClick={() => setActiveWeek("Week 2")}
              >
                Week 2
              </button>
            </div>
            <div className="header-row">
              <div className="assigned-to-header">Assigned To</div>
              {currentWeekDates.map((dateHeader, index) => (
                <div key={index} className="date-header">
                  {dateHeader.label}
                </div>
              ))}
            </div>
            {scheduleData.map((row, index) => (
              <div key={index} className="schedule-row">
                <div className="analyst-name-box">
                  {row.analyst}
                </div>
                {currentWeekDates.map((dateHeader, dateIndex) => {
                  const cell = row[dateHeader.key];
                  return (
                    <div key={dateIndex} className="schedule-grid-box">
                      {hasSearched && cell && (
                        <div className="task-tags-container">
                          {cell.products?.map((product, idx) => (
                            <div
                              key={idx}
                              className="task-tag default-font-styles"
                              title={`${product.name}(${product.count || product.productCount})`}
                            >
                              <span className="task-tag-text">
                                {product.name}({product.count || product.productCount})
                              </span>
                              <button
                                className="close-button"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleDeleteClick(
                                    product.name,
                                    row.analyst,
                                    dateHeader.key,
                                    product.sampleIds
                                  );
                                }}
                              >
                                <img
                                  src={CloseVector}
                                  alt="Close"
                                  className="close-button-image"
                                />
                              </button>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
          <div className="sample-list">
            <div className="sample-list-header">
              <h3 className="sample-list-title default-font-styles">
                Current Sample List
              </h3>
              <div className="sample-list-subtitle default-font-styles">
                (Click on Product Type to Select)
              </div>
            </div>
            <div className="sample-items-container">
              {currentSampleList.map((sample) => (
                <div
                  key={sample.id}
                  className="sample-item"
                  onClick={() => openSamplePopup(sample)}
                >
                  <div className="sample-id">
                    <div className="sample-id-inner">
                      <span>{sample.name}</span>
                      <span className={`status-dot ${sample.status}`}></span>
                    </div>
                  </div>
                  <div className="sample-details">
                    Assay ({sample.assayCount}) | ReAssay 1 (
                    {sample.reAssay1Count}) | ReAssay 2 ({sample.reAssay2Count})
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {showPopup && (
          <div className="popup-overlay">
            <div
              className={`assignment-popup${isPopupDragging ? " assignment-popup-dragging" : ""}`}
              style={{
                "--popup-drag-x": `${popupDragOffset.x}px`,
                "--popup-drag-y": `${popupDragOffset.y}px`,
              }}
            >
              <div className="assignment-popup-header" onPointerDown={handlePopupHeaderPointerDown}>
                <span className="assignment-popup-title">Product Type: {selectedProduct?.name}</span>
                <button
                  className="popup-close-button"
                  onClick={handlePopupClose}
                >
                  <img src={CloseIcon} alt="Close" />
                </button>
              </div>
              <div className="assignment-popup-content">
                <div className="assignment-controls">
                  <div className="control-group">
                    <label className="control-label">Select Analyst</label>
                    <select
                      className="control-select"
                      value={selectedAnalyst}
                      onChange={handleAnalystSelection}
                    >
                      <option value="">Select Analyst</option>
                      {analysts.map((analyst) => (
                        <option
                          key={analyst.userId || analyst.id}
                          value={analyst.userId || analyst.id}
                        >
                          {analyst.fullName || analyst.name || analyst.userName}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="control-group">
                    <label className="control-label">Select Date</label>
                    <div className="date-input-wrapper">
                      <input
                        type="text"
                        value={selectedDate ? formatDateForDisplay(selectedDate) : ""}
                        readOnly
                        className="control-date-input"
                        placeholder="Select date"
                      />
                      <img
                        src={CalanderIcon}
                        alt="Calendar"
                        className="calendar-icon"
                      />
                      <input
                        type="date"
                        value={selectedDate || ""}
                        onChange={handleDateSelection}
                        className="date-input-hidden"
                        min={getTodayDateString()}
                      />
                    </div>
                  </div>
                  <div className="control-group">
                    <label className="control-label">Assigned Product(s)</label>
                    <div className="assigned-products horizontal-scroll">
                      {assignedProductsFromSchedule && assignedProductsFromSchedule.length > 0 ? (
                        <div className="assigned-products-list">
                          {assignedProductsFromSchedule.map((product, index) => (
                            <span key={index} className="assigned-product-item">
                              {product.displayText ||
                                product.productWithSampleCount ||
                                `${product.productTypeName || product.name || 'Unknown'}(${product.count || product.productCount || 0})`}
                              {index < assignedProductsFromSchedule.length - 1 ? ", " : ""}
                            </span>
                          ))}
                        </div>
                      ) : (
                        <span className="no-assigned-products">NIL</span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="samples-section">
                  <h4 className="samples-title">Select Samples to Assign</h4>
                  <div className="samples-table-container">
                    {productSamplesLoading ? (
                      <div>Loading...</div>
                    ) : (
                      <table className="samples-table">
                        <thead className="samples-table-header">
                          <tr>
                            <th className="samples-table-th">
                              <input
                                type="checkbox"
                                className="checkbox"
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    setSelectedSamples(
                                      productSamples.map(
                                        (sample) => sample.sampleId
                                      )
                                    );
                                  } else {
                                    setSelectedSamples([]);
                                  }
                                }}
                                checked={
                                  selectedSamples.length ===
                                  productSamples.length &&
                                  productSamples.length > 0
                                }
                              />
                            </th>
                            <th className="samples-table-th">Sample ID</th>
                            <th className="samples-table-th">Product</th>
                            <th className="samples-table-th">Company</th>
                            <th className="samples-table-th">Date</th>
                            <th className="samples-table-th">Unit</th>
                            <th className="samples-table-th">Exp Level</th>
                            <th className="samples-table-th">Low Limit</th>
                            <th className="samples-table-th">High Limit</th>
                            <th className="samples-table-th">status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {productSamples.map((sample) => (
                            <tr
                              key={sample.sampleId}
                              className={`samples-table-row ${selectedSamples.includes(sample.sampleId) ? "selected" : ""}`}
                            >
                              <td className="samples-table-td">
                                <input
                                  type="checkbox"
                                  className="checkbox"
                                  checked={selectedSamples.includes(
                                    sample.sampleId
                                  )}
                                  onChange={() => {
                                    setSelectedSamples((prev) =>
                                      prev.includes(sample.sampleId)
                                        ? prev.filter(
                                          (id) => id !== sample.sampleId
                                        )
                                        : [...prev, sample.sampleId]
                                    );
                                  }}
                                />
                              </td>
                              <td className="samples-table-td">
                                {sample.sampleId}
                              </td>
                              <td className="samples-table-td">
                                {sample.productName}
                              </td>
                              <td className="samples-table-td">
                                {sample.companyName}
                              </td>
                              <td className="samples-table-td">
                                {sample.date ? formatDateDDMMYY(sample.date) : ""}
                              </td>
                              <td className="samples-table-td">{sample.unit}</td>
                              <td className="samples-table-td">
                                {sample.expectedLevel}
                              </td>
                              <td className="samples-table-td">
                                {sample.lowLimit}
                              </td>
                              <td className="samples-table-td">
                                {sample.highLimit}
                              </td>
                              <td className="samples-table-td">
                                {sample.status}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                  </div>
                  <div className="popup-footer">
                    <button
                      className="btn-common outlined-active-btn btn-md default-font-styles"
                      onClick={handlePopupClose}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn-common active-btn btn-md default-font-styles"
                      onClick={handleAssign}
                    >
                      Assign
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {showDeleteConfirm && (
          <div className="popup-overlay delete-popup-overlay">
            <div className="delete-popup">
              <div className="delete-popup-header">
                <span className="delete-popup-title">Remove Assigned Samples</span>
                <button
                  className="popup-close-button"
                  onClick={() => {
                    setShowDeleteConfirm(false);
                    setSelectedSamplesToDelete([]);
                    setSamplesForRemove([]);
                  }}
                >
                  <img src={CloseIcon} alt="Close" />
                </button>
              </div>
              <div className="delete-popup-content">
                <div className="delete-message">
                  Select samples to remove:
                </div>
                <div className="delete-samples-list">
                  <div className="delete-samples-header">
                    <input
                      type="checkbox"
                      className="checkbox"
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSelectedSamplesToDelete(deleteTaskInfo.sampleIds || []);
                        } else {
                          setSelectedSamplesToDelete([]);
                        }
                      }}
                      checked={
                        selectedSamplesToDelete.length === (deleteTaskInfo.sampleIds?.length || 0) &&
                        (deleteTaskInfo.sampleIds?.length || 0) > 0
                      }
                    />
                    <span className="select-all-label">Sample ID</span>
                    <span className="select-all-label">Product Name</span>
                  </div>
                  <div className="delete-samples-container">
                    {samplesForRemove.map((sample, index) => (
                      <div key={index} className="delete-sample-item">
                        <input
                          type="checkbox"
                          className="checkbox"
                          checked={selectedSamplesToDelete.includes(sample.sampleId)}
                          onChange={() => {
                            setSelectedSamplesToDelete((prev) =>
                              prev.includes(sample.sampleId)
                                ? prev.filter((id) => id !== sample.sampleId)
                                : [...prev, sample.sampleId]
                            );
                          }}
                        />
                        <span className="sample-id-text">{sample.sampleId}</span>
                        <span className="sample-product-text">{sample.productName}</span>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="delete-popup-footer">
                  <button
                    className="btn-common outlined-active-btn btn-md default-font-styles"
                    onClick={() => {
                      setShowDeleteConfirm(false);
                      setSelectedSamplesToDelete([]);
                      setSamplesForRemove([]);
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn-common active-btn btn-md default-font-styles"
                    onClick={handleConfirmDelete}
                    disabled={selectedSamplesToDelete.length === 0}
                  >
                    Remove
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </Fragment>
  );
};

export default Scheduler;
